/* eslint-disable @next/next/no-img-element */
import React from 'react';
import { PrismicLink } from '@prismicio/react';
import { Post } from '@/shared/types/blog';
import './index.less';
import { imgix } from '@/shared/utils/utils';
import { ImgixFitType } from '@/shared/types/imgix';
import Imgix from 'react-imgix';

const BlogCard = ({ post }: { post: Post }) => {
  return (
    <PrismicLink document={post} className="blog-card-container">
      <div className="blog-card-image">
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <Imgix
          src={imgix(post?.data?.image.url, { fit: ImgixFitType.CROP })}
          sizes="(max-width: 831.99px) calc(100vw - 32px), 524px"
          htmlAttributes={{ width: 524, height: 274, alt: 'blog image', loading: 'lazy' }}
        />
      </div>
      <div className="blog-card-info">
        <div className="header">
          <span>{post?.data?.category}</span>
          <span className="dot"></span>
          {post?.data?.reading_time && <span>{post?.data?.reading_time} MIN</span>}
        </div>
        <div className="title">{post?.data?.title}</div>
        <div className="desc">{post?.data?.seo_description}</div>
        <div className="author-info">
          {post?.data?.author_avator?.url && (
            <>
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img
                width={36}
                height={36}
                src={imgix(post.data.author_avator.url, { q: 90, w: 54, h: 54 })}
                className="avator"
                alt="author avator"
                loading="lazy"
              />
            </>
          )}
          <div className="author">
            <p>{post?.data?.author}</p>
            <p>{post?.data?.author_position}</p>
          </div>
        </div>
      </div>
    </PrismicLink>
  );
};

export default BlogCard;
